// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_availability_order_notice = /** @type {(inputs: {}) => string} */ () => {
	return `delivery time starts when you place your order`
};

const el_availability_order_notice = /** @type {(inputs: {}) => string} */ () => {
	return `ο χρόνος παράδοσης ξεκινά όταν ολοκληρώσετε την παραγγελία`
};

const ru_availability_order_notice = /** @type {(inputs: {}) => string} */ () => {
	return `срок доставки начинается с момента оформления заказа`
};

const he_availability_order_notice = /** @type {(inputs: {}) => string} */ () => {
	return `זמן המשלוח מתחיל מרגע ביצוע ההזמנה`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const availability_order_notice = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.availability_order_notice(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("availability_order_notice", locale)
	if (locale === "en") return en_availability_order_notice(inputs)
	if (locale === "el") return el_availability_order_notice(inputs)
	if (locale === "ru") return ru_availability_order_notice(inputs)
	if (locale === "he") return he_availability_order_notice(inputs)
	return "availability_order_notice"
};